import sortLinks from './sortLinks';
export const utils = {
  sortLinks
};
flarum.reg.add('fof-links', 'common/utils', null);